import React, { useState } from "react";
import Style from "./TermsofUse.module.scss";
import Button from "react-bootstrap/Button";
import Assets from "../../Layout/Assets";
import {
  Responsibilities,
  refund,
  Links,
} from "../../Constants/TermsAndConditions/Insideindia";
import { HmacSHA256 } from "crypto-js";

function InsideIndia() {
  const [InsideIndia, setTerms] = useState(true);

  return (
    <>
      <div>
        
      <h3 className={Style.headings}>Terms and Conditions</h3>
        <p className={Style.content}>
        	We as a merchant shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
        </p>
      </div>

      <div>
        <h3 className={Style.headings}>Q. What is the preset limit & how will a Cardholder know it? Can you show the Tx limit?</h3>
        <ul>
            <li>Please review our Privacy Policy and Cancellation Policy.</li>
            <li><strong>Geri Care</strong> is not responsible / liable for the misuse of Tele-Consultation facility provided.</li>
            <li>Geri Care is not liable for the outcome of the Tele-Consultation if there is any connectivity problem or bandwidth interruption</li>
            <li>Appointments once taken cannot be cancelled. It can however be rescheduled  with prior intimation 48 hrs before the original schedule date & time.</li>
            <li>If the consultant is not available due to some emergency, an alternate doctor shall be engaged for the consultation</li>

            <li>If due to unforeseen circumstances the teleconsultation gets cancelled, an alternate slot shall be allowed, depending upon Consultant availability and the patient's convenience. 	The Tele-Consultation  is only an interactive session and does not involve any medico legal issues. </li>
            <li>Please read the "Terms and Conditions" given in the website before proceeding with the Teleconsultation</li>
            <li>Please read the Patient Instruction Leaflet before the start of Teleconsultation</li>
            
        </ul>
      </div>

      <div>
        <h3 className={Style.headings}>Instructions</h3>
        <ul>
        <li>	Kindly report for the Tele-consultation on time.</li>
            <li>	Please be precise and pass on important information in order of your priority. </li>
            <li>	The advice given is solely  based upon the interaction during the Tele-Consulting session.</li>
            <li>	Please  have soft copies (scanned) of all relevant relevant medical reports and documents readily available with you prior to the consultation or for uploading.</li>
            <li>	For optimal use of your Tele-Consultation time, please upload all relevant medical records  before consultation.</li>
            <li>	There is a facility to upload documents through this portal for your use.</li>
            <li>	Kindly make maximum use of your Session time.A good option is to write down everything which you need to communicate to the consultant</li>
            <li>	If you have not been able to follow / understand the consultant in any manner,, please clarify immediately during the teleconsultation itself.</li>
            <li>	Kindly Call / email the Telemedicine Help Desk for any queries or assistance. Call: +914440614061     | Email:   
                <a href="mailto:enquiry@gericare.in">enquiry@gericare.in</a></li>
                </ul>
      </div>
      <div>
        <h3 className={Style.headings}>Privacy Policy</h3>
        <p>We use a secure server for credit card transactions to protect the credit card information of our users. The information we gather from members is not shared with any individual or organization. We do not sell, rent, or loan any identifiable information at the individual level to any third party</p>
        </div>
        <div>
        <h3 className={Style.headings}>Cancellation Policy</h3>
        <p>No Cancellation. Once you register for the Telemedicine facility, it cannot be cancelled.</p>
        </div>
        <div>
        <h3 className={Style.headings}>Refund Policy</h3>
        <p>There is no refund option available for this telemedicine facility. The amount paid for registering for the telemedicine facility will not be refunded under any circumstances.</p>
        </div>
      
    </>
  );
}

export default InsideIndia;
